import { FEATURE_MNG } from '@/api/apiModules'
export default {
  viewType: 'detail',
  toolbar: {
    hasRefresh: false
  },
  class: 'wsp-cusotm-dialog-detail-page-view',
  view: {
    tabs: [
      {
        label: 'baseInfo',
        viewMetaData: {
          module: FEATURE_MNG,
          params: null,
          fillDetailUrl: `${FEATURE_MNG}/detail`,
          viewType: 'form',
          cb() {},
          view: {
            isSimple: false,
            labelWidth: '180px',
            header: {},
            content: [
              {
                isGroup: true,
                $type: 'group',
                $id: 'base',
                title: 'overview',
                icon: 'sk-icon-overview',
                $items: [
                  {
                    $id: 'featureName',
                    label: '功能名'
                  },
                  {
                    $id: 'featureType',
                    label: '售前功能类型',
                    dataType: 'enum'
                  },
                  {
                    $id: 'deliveryFeatureType',
                    label: '交付功能类型',
                    dataType: 'enum'
                  },
                  {
                    $id: 'featureCategory',
                    label: '功能分类',
                    dataType: 'enum'
                  },
                  {
                    $id: 'desktopArch',
                    label: '适用桌面架构'
                  },
                  {
                    $id: 'userRole',
                    label: '功能使用角色'
                  },
                  {
                    $id: 'valueDesc',
                    label: '业务诉求【主打价值】'
                  },
                  {
                    $id: 'schemeDesign',
                    label: '测试说明'
                  },
                  {
                    $id: 'expectedOutcome',
                    label: '预期效果'
                  },
                  {
                    $id: 'competitiveList',
                    label: '竞争力信息',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.competitiveList || data.competitiveList.length == 0) {
                        return
                      }
                      const renderItem = []
                      data.competitiveList.forEach(el => {
                        renderItem.push(
                          <div class="wsp-margin-left-3 wsp-margin-top-3">
                            <span>
                              【友商：{el.competitorCn}】
                              <el-tag
                                type={
                                  el.competitiveness === '优势'
                                    ? 'success'
                                    : el.competitiveness === '劣势'
                                    ? 'danger'
                                    : el.competitiveness === '持平'
                                    ? 'primary'
                                    : 'warning'
                                }
                              >
                                {el.competitiveness}
                              </el-tag>
                              &nbsp;&nbsp;{el.competitiveComparison}
                            </span>
                          </div>
                        )
                      })
                      return renderItem
                    }
                  },
                  {
                    $id: 'limitDesc',
                    label: '相关限制说明'
                  },
                  {
                    $id: 'resolveIssues',
                    label: '解决客户问题'
                  },
                  {
                    $id: 'configStep',
                    label: '功能/方案配置步骤'
                  },
                  {
                    $id: 'configStepLink',
                    label: '功能配置文档'
                  },
                  {
                    $id: 'video',
                    label: '视频演示'
                  },
                  {
                    $id: 'input',
                    label: 'PPT演示'
                  },
                  {
                    $id: 'sceneVOList',
                    label: '关联场景',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.sceneVOList || data.sceneVOList.length == 0) {
                        return
                      }
                      const renderItem = []
                      data.sceneVOList.forEach(el => {
                        renderItem.push(
                          <div class="wsp-margin-left-3 wsp-margin-top-3">
                            <span>
                              【{el.industryName}】{el.sceneName}
                            </span>
                          </div>
                        )
                      })
                      return renderItem
                    }
                  }
                ]
              }
            ]
          }
        }
      },
      {
        label: '关联用例',
        viewMetaData: import('./relateTestCaseTable')
      }
    ]
  }
}
